import { render, staticRenderFns } from "./IconCardArrow.vue?vue&type=template&id=2fbfd0aa"
import script from "./IconCardArrow.vue?vue&type=script&lang=js"
export * from "./IconCardArrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports